import { Injectable } from '@angular/core';

export interface RuntimeConfig {
  /** Base URL of the API. Empty = same origin (recommended, behind one reverse proxy). */
  apiUrl: string;
}

/** Loads /config.json at startup so one build can be deployed to any environment. */
@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: RuntimeConfig = { apiUrl: '' };

  async load(): Promise<void> {
    try {
      const res = await fetch('config.json', { cache: 'no-store' });
      if (res.ok) this.config = { ...this.config, ...(await res.json()) };
    } catch {
      /* keep defaults */
    }
  }

  get apiUrl(): string {
    return this.config.apiUrl.replace(/\/$/, '');
  }
}
